import { useContext } from "react";
import { DownloadCSVTemplateContext } from "./DownloadCSVTemplateProvider";

export default function useDownloadCSVTemplateContext() {
    return useContext(DownloadCSVTemplateContext);
};
